<template>
    <b-card
        class="list-container shadow-sm"
        bg-variant="white"
        no-body
    >
        <template #header>
            <div class="d-flex align-items-center justify-content-between" style="height: 36px">
                <div>
                    <h6 class="mb-0">연결 프로젝트 목록</h6>
                </div>
            </div>
        </template>
        <b-table
            :items="projects"
            :fields="tableColumns"
            class="mb-0 sticky-header-sort-fix custom-table"
            :sticky-header="true"
            :empty-html="getEmptyTableHTML"
            show-empty
            responsive
        >
            <template #cell(status_code)="data">
                <b-badge :variant="statusVariant(data.value)">
                    {{ statusLabel(data.value) }}
                </b-badge>
            </template>
            <template #cell(detail)="data">
                <b-btn size="sm" variant="outline-primary"
                       @click="enterProject(data.item)"
                >
                    확인하기
                </b-btn>
            </template>
        </b-table>
    </b-card>
</template>

<script>
import { getEmptyTableHTML } from '@shared/components/admin/pages/Management/common-data';
import assessmentCommonMixin from '@shared/mixin/assessment.common.mixin';

export default {
    name: 'ConnectedProject',
    mixins: [assessmentCommonMixin],
    props: {
        selected_company: {
            type: Object,
            required: true,
            default: () => ({ id: null }),
        }
    },
    computed: {
        projects() {
            return this.selected_company.projects || [];
        },
        tableColumns() {
            return [
                { key: 'project_code', label: '프로젝트 코드' },
                { key: 'client', label: '원청사', thStyle: { width: '140px' } },
                { key: 'campaign_id', label: '캠페인 ID', thStyle: { width: '100px' }, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'period', label: '참여기간', thStyle: { width: '100px' }, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'industry_name', label: '평가산업', thStyle: { width: '120px' } },
                { key: 'status_code', label: '상태', thStyle: { width: '80px' }, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'detail', label: '', thStyle: { width: '100px' }, thClass: 'text-center', tdClass: 'text-center' },
            ];
        },
        getEmptyTableHTML() {
            return getEmptyTableHTML('연결된 프로젝트가 없습니다.');
        },
    },
    methods: {
        statusLabel(code) {
            return this.getProgressStatus({ status_code: code });
        },
        statusVariant(code) {
            return this.getProgressColor({ status_code: code });
        },
        enterProject(project) {
            this.$router.push({
                name: 'ProjectProgress',
                query: {
                    client: project.client,
                    pc: project.project_code,
                    cmp: project.campaign_id,
                    admin_mode: 'project'
                }
            });
        },
    }
};
</script>
